import { createUseStyles } from 'react-jss';
export default createUseStyles(function (theme) {
  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      maxWidth: 330,
      justifyContent: 'center',
      boxSizing: 'border-box'
    },
    input: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      padding: '0 16px',
      height: 48,
      width: '100%',
      borderRadius: 5,
      border: "1px solid ".concat(theme.palette.grey[15]),
      cursor: 'pointer',
      marginTop: 10
    },
    inputError: {
      borderColor: theme.palette.red.light,
      opacity: 1,
      outline: 'none'
    },
    bottomError: {
      marginTop: 3
    },
    icon: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      width: 'auto'
    },
    menu: {
      border: "1px solid ".concat(theme.palette.grey[15])
    },
    label: {
      width: '100%'
    },
    placeholder: {
      color: theme.palette.grey[11]
    },
    option: {
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: 'white',
      borderRadius: 5,
      border: '1px solid #c1c1c1',
      zIndex: 1001,
      maxHeight: 170,
      overflowY: 'auto',
      overflowX: 'hidden',
      boxShadow: '0px 20px 20px #00000029',
      boxSizing: 'border-box'
    },
    optionAbsolute: {
      width: 'calc(100% + 2px)',
      position: 'absolute',
      top: '100%',
      left: -1
    },
    optionFixed: {
      position: 'fixed',
      left: '50%',
      transform: 'translateX(-50%)'
    },
    disabled: {
      cursor: 'not-allowed',
      backgroundColor: theme.palette.grey[1],
      color: theme.palette.grey[11]
    }
  };
});